import { motion } from "framer-motion";
import { TrendingUp, ArrowRightLeft, Sparkles, Layers } from "lucide-react";

const ProblemSection = () => {
  const solutions = [
    {
      icon: TrendingUp,
      title: "Estimer",
      description: "Comprendre la valeur et le potentiel de son actif forestier."
    },
    {
      icon: ArrowRightLeft,
      title: "Vendre",
      description: "Préparer et accompagner la cession d'une forêt ou d'une parcelle boisée."
    },
    {
      icon: Sparkles,
      title: "Valoriser",
      description: "Étudier les opportunités liées aux bois, au foncier et aux usages de la propriété."
    },
    {
      icon: Layers,
      title: "Recomposer",
      description: "Regrouper des parcelles morcelées pour recréer des ensembles plus cohérents."
    }
  ];

  return (
    <section
      id="valorisation"
      data-testid="problem-section"
      className="py-24 md:py-32 bg-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
              Patrimoine Forestier
            </p>
            <h2
              className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest mb-6"
              data-testid="problem-headline"
            >
              Un actif forestier peut être valorisé de plusieurs façons
            </h2>
            <div className="section-divider mb-8" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="font-sans text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Vendre une propriété, céder des bois, sortir d'une indivision, regrouper des parcelles ou simplement comprendre la valeur de son patrimoine : chaque situation forestière nécessite une approche différente.
            </p>
            <p className="font-sans text-base md:text-lg text-gray-700 leading-relaxed">
              <strong className="text-forest">Sylva Invest analyse le foncier, la situation du propriétaire et ses objectifs</strong> afin d'identifier la solution la plus pertinente.
            </p>
          </motion.div>
        </div>

        {/* 4 points visuels */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => (
            <motion.div
              key={solution.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 border-l-4 border-gold"
              data-testid={`solution-${index}`}
            >
              <solution.icon className="w-8 h-8 text-gold mb-4" />
              <h3 className="font-serif text-xl text-forest mb-3">
                {solution.title}
              </h3>
              <p className="font-sans text-sm text-gray-600 leading-relaxed">
                {solution.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
